var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGiphy = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17,4 L19,4 L19,0 L15,0 L15,2 L17,2 L17,4 Z M12,3 L5,3 L5,18 L16,18 L16,7 L12,7 L12,3 Z M3,0 L19,0 L19,20 C19,20.5522847 18.5522847,21 18,21 L3,21 C2.44771525,21 2,20.5522847 2,20 L2,1 L2,1 C2,0.44771525 2.44771525,1.01453063e-16 3,0 L3,0 Z"
})))));
export default SvgGiphy;